import Grid from "@material-ui/core/Grid";
import { makeStyles, Theme } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import React, { useState } from "react";
import CustomMultipleTextField from "../../../components/Input/CustomMultipleTextField";
import useChangingDebounce from "../../../hooks/useChangingDebounce.hook";
import AdminUserOverviewFilters, { UserActivityFilters } from "./AdminUserOverviewFilters";
import AdminUserOverviewTable from "./AdminUserOverviewTable";

const useStyles = makeStyles((theme: Theme) => ({
  marginBottom5: {
    marginBottom: theme.spacing(5),
  },
  subHeading: {
    display: "block",
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: "1.5rem",
    marginBottom: theme.spacing(1),
  },
}));

const initialFilters: UserActivityFilters = {
  groups: [],
  labs: [],
  roles: [],
};

interface AdminUserOverviewProps {}

const AdminUserOverview: React.FC<AdminUserOverviewProps> = () => {
  const classes = useStyles();
  const [terms, setTerms] = useState<string[]>([]);
  const [filters, setFilters] = useState<UserActivityFilters>(initialFilters);
  const [debouncedTerms, waitingTerms] = useChangingDebounce(terms, 1000);
  const [debouncedFilters, waitingFilters] = useChangingDebounce(filters, 1000);

  const handleFilterChange = (changedFilters: UserActivityFilters) => {
    setFilters(changedFilters);
  };

  return (
    <div className={classes.marginBottom5}>
      <div className={classes.subHeading}>User Overview</div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CustomMultipleTextField
            fullWidth
            clearable
            value={terms}
            onChange={(value) => setTerms(value)}
            placeholder="Search Users"
            placeholderIcon={<SearchIcon />}
          />
        </Grid>
        <Grid item xs={12}>
          <AdminUserOverviewFilters handleFilterChange={handleFilterChange} initialValues={filters} />
        </Grid>
        <Grid item xs={12}>
          <AdminUserOverviewTable
            filters={debouncedFilters}
            terms={debouncedTerms}
            waiting={waitingTerms || waitingFilters}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default AdminUserOverview;
